<div class="loader-container" *ngIf="loaderService.loader$ | async">
  <div class="loader">
    <div class="circle"></div>
  </div>
</div>
